import { PropertyListingType } from "@/enums/property.enum";
import { useTranslations } from "next-intl";
import { Tabs, TabsList, TabsTrigger } from "../ui/Tabs";

interface ListingTypeTabsProps {
  value: PropertyListingType;
  onChange: (value: PropertyListingType) => void;
}

export const ListingTypeTabs = ({ onChange, value }: ListingTypeTabsProps) => {
  const st = useTranslations("shared");

  return (
    <Tabs
      variant="underline"
      value={value}
      onValueChange={(value) => {
        onChange(value as PropertyListingType);
      }}
    >
      <div className="overflow-x-auto">
        <TabsList>
          {Object.values(PropertyListingType).map((tab) => (
            <TabsTrigger value={tab} key={tab} className="px-4 capitalize">
              {st(`listing-type.${tab}`)}
            </TabsTrigger>
          ))}
        </TabsList>
      </div>
    </Tabs>
  );
};
